enum DropShippingProcessingStatus {
    /**待审核 */
    PENDING_APPROVAL = "PENDING_APPROVAL",
    /**处理中 */
    PROCESSING = "PROCESSING",
}

export default DropShippingProcessingStatus;
